import type { ReactNode } from 'react';
import { _LoginInfo } from 'autogen/swagger/all';
import { Button } from 'components/Button';
import type IButton from 'components/Button/shared/types/button';
import useLoginInfoQuickView from 'components/login/shared/hooks/useLoginInfoQuickView';
import useIsAuthenticated from 'hooks/user/useIsAuthenticated';

export default function CMSLoginButton({ children, ...restProps }: { children: ReactNode } & IButton) {
    const isAuthenticated = useIsAuthenticated();
    const [, toggle] = useLoginInfoQuickView();

    if (isAuthenticated) return null;

    function getLoginInfo() {
        _LoginInfo({
            infoType: 'General',
            level: 'Soft',
            mode: 'Standard',
            returnUrl: window.location.pathname
        }).then((loginInfo) => {
            toggle({ isOpen: true, loginInfo });
        });
    }

    return (
        <Button onClick={getLoginInfo} {...restProps}>
            {children}
        </Button>
    );
}
